import { UserAvatarFilled } from '@carbon/icons-react';
import { cx } from '../../utils';
import { CdIndicatorDot } from '../CdIndicatorDot';
import styles from './CdAvatar.module.scss';

const iconSize = { sm: 16, md: 20, lg: 32, xl: 48 } as const;

export interface CdAvatarProps {
  /** Initials to show instead of the default user icon. */
  initials?: string;
  /** Shows the red badge dot (e.g. pending account action). */
  hasBadge?: boolean;
  /** `sm`/`md` for inline icons, `lg` for the header trigger, `xl` for profile cards. */
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

/** Decorative user avatar. Wrap it in a button/menu trigger that carries the accessible name. */
export const CdAvatar = ({ initials, hasBadge = false, size = 'md', className }: CdAvatarProps) => {
  return (
    <span className={cx(styles.avatar, styles[size], className)} aria-hidden="true">
      {initials ? (
        <span className={styles.initials}>{initials}</span>
      ) : (
        <UserAvatarFilled size={iconSize[size]} />
      )}
      {hasBadge && <CdIndicatorDot className={styles.badge} />}
    </span>
  );
};
